module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"faq":"Frequently Asked Questions","contact":"Contacts","leave_faq":"OK"},"zhHant":{"faq":"常見問題","contact":"聯絡我們","leave_faq":"OK"},"ja":{"faq":"よくある質問","contact":"お問い合わせ","leave_faq":"OK"},"ko":{"faq":"자주 묻는 질문 QnA","contact":"문의","leave_faq":"OK"}}')
  delete Component.options._Ctor
}
